import React from 'react'

import { Skeleton } from '@fourthwall/components'

export const ArticlesSkeleton = () => (
  <div>
    <Skeleton gap={20}>
      <Skeleton.Shape width="100%" height={190} />
      <Skeleton.Shape width="100%" height={190} />
    </Skeleton>
  </div>
)
